var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',_vm._g(_vm._b({ref:"autocomplete",staticClass:"x-autocomplete",attrs:{"menu-props":{ripple: false}},scopedSlots:_vm._u([_vm._l((_vm.$scopedSlots),function(_,scopedSlotName){return {key:scopedSlotName,fn:function(data){return [_vm._t(scopedSlotName,null,null,data)]}}}),_vm._l((_vm.$slots),function(_,slotName){return {key:slotName,fn:function(){return [_vm._t(slotName)]},proxy:true}})],null,true)},'v-autocomplete',{
    ..._vm.$attrs,
    ..._vm.commonAttrs
  },false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }